export default __webpack_public_path__ + "static/media/activePortfolio.ed4235b6.png";